var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { SubmissionError } from 'redux-form';
import { apiCreateProfessionalRequestService } from '../../../actions/ProfessionalRequestServiceAction';
import { apiGetOneProfile } from '../../../actions/ProfileActions';
import { wrapNotifyError, wrapDispatch } from '../../action';
import { createValidateErrorData, hasReduxFormError } from '../../validate';
import { useBoolState } from '../useHook';
/**
 * Proffitへの組織登録申請を制御するuse
 * @param profile
 * @param dispatch
 * @param unmountRef
 * @param onSubmitAfter
 * @returns {*}
 */
export const useProfessionalRequestServiceModal = (profile, dispatch, unmountRef, onSubmitAfter) => {
    const { boolState: isShowFormModal, changeFalse: hideFormModal, changeTrue: showFormModal, } = useBoolState(false);
    const { boolState: isShowCompleteModal, changeFalse: hideCompleteModal, changeTrue: showCompleteModal, } = useBoolState(false);
    /**
     * submit時のイベント
     * @type {(function(*): Promise<void>)|*}
     */
    const onSubmit = useCallback((formValues = {}) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield wrapDispatch(dispatch, apiCreateProfessionalRequestService(formValues));
                if (unmountRef.current) {
                    return;
                }
                yield wrapDispatch(dispatch, apiGetOneProfile());
                if (formValues.organizationName) {
                    // 会社名の入力があれば完了モーダルを表示
                    hideFormModal();
                    showCompleteModal();
                }
                if (onSubmitAfter) {
                    onSubmitAfter(formValues);
                }
            }
            catch (e) {
                if (unmountRef.current) {
                    return;
                }
                const errorMessage = createValidateErrorData(e);
                if (hasReduxFormError(errorMessage)) {
                    throw new SubmissionError(errorMessage);
                }
                else {
                    throw e;
                }
            }
        }));
    }), [dispatch, hideFormModal, showCompleteModal, unmountRef, onSubmitAfter]);
    return {
        hideCompleteModal,
        hideFormModal,
        isShowCompleteModal,
        isShowFormModal,
        onSubmit,
        showCompleteModal,
        showFormModal,
    };
};
export const useProfessionalRequestService = {
    useProfessionalRequestServiceModal,
};
